// extracted by mini-css-extract-plugin
module.exports = {"link":"History_link__j_sew","linkTextSecondPart":"History_linkTextSecondPart__HcbwE"};